export default {
      id: "gps-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.svg#gps",
      toString: function () {
        return this.url;
      }
    }